export default __webpack_public_path__ + "static/media/camping.b0d2cf6f.jpg";